'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import React, { useState } from 'react';
import { CaseStudyCard } from '@/components/page-builder/global/caseStudiesFilters/CaseStudyCard';
import { Button } from '@/components/ui/button';
export function CaseStudiesResults(t0) {
  const $ = _c(23);
  const {
    results,
    reviewBannerSlot
  } = t0;
  const searchParams = useSearchParams();
  const t = useTranslations("CaseStudiesResults");
  const [showAllCaseStudies, setShowAllCaseStudies] = useState(false);
  let filteredCaseStudies;
  let t1;
  let t2;
  let t3;
  let visibleCaseStudies;
  if ($[0] !== results || $[1] !== reviewBannerSlot || $[2] !== searchParams || $[3] !== showAllCaseStudies) {
    const industryFilters = searchParams.getAll("industry");
    const integrationsFilters = searchParams.getAll("integrations");
    const companyFilters = searchParams.getAll("company_size");
    const languageFilters = searchParams.getAll("target_languages");
    const matchesFilter = _temp;
    filteredCaseStudies = results.filter(caseStudy => {
      const industry = caseStudy.industry?.industry ? [caseStudy.industry.industry] : [];
      const company = caseStudy.companySize?.companySize ? [caseStudy.companySize.companySize] : [];
      const integrations = caseStudy.integrations?.map(_temp2) ?? [];
      const languages = caseStudy.languages?.map(_temp3).filter(Boolean) as string[] ?? [];
      const matchesIndustry = matchesFilter(industryFilters, industry);
      const matchesCompany = matchesFilter(companyFilters, company);
      const matchesIntegrations = matchesFilter(integrationsFilters, integrations);
      const matchesLanguages = matchesFilter(languageFilters, languages);
      return matchesIndustry && matchesCompany && matchesIntegrations && matchesLanguages;
    });
    visibleCaseStudies = showAllCaseStudies ? filteredCaseStudies : filteredCaseStudies.slice(0, 12);
    t3 = "flex flex-col gap-10";
    t1 = "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3  gap-x-10 lg:gap-y-15 gap-y-10";
    let t4;
    if ($[9] !== reviewBannerSlot) {
      t4 = (caseStudy_0, index) => <React.Fragment key={caseStudy_0.id}><CaseStudyCard slug={caseStudy_0.slug} title={caseStudy_0.title} primaryImage={caseStudy_0.heroBanner?.primaryImage} previewImage={caseStudy_0?.previewImage} brandTitle={caseStudy_0.brandTitle} />{reviewBannerSlot && index === 5 ? reviewBannerSlot : null}</React.Fragment>;
      $[9] = reviewBannerSlot;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t2 = visibleCaseStudies.map(t4);
    $[0] = results;
    $[1] = reviewBannerSlot;
    $[2] = searchParams;
    $[3] = showAllCaseStudies;
    $[4] = filteredCaseStudies;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = visibleCaseStudies;
  } else {
    filteredCaseStudies = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    visibleCaseStudies = $[8];
  }
  const t4 = reviewBannerSlot && visibleCaseStudies.length <= 6 ? reviewBannerSlot : null;
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== filteredCaseStudies || $[16] !== showAllCaseStudies || $[17] !== t) {
    t6 = !showAllCaseStudies && filteredCaseStudies.length > 12 ? <Button className="mx-auto" onClick={() => setShowAllCaseStudies(true)}>{t("showMore")}</Button> : null;
    $[15] = filteredCaseStudies;
    $[16] = showAllCaseStudies;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t3 || $[20] !== t5 || $[21] !== t6) {
    t7 = <div className={t3}>{t5}{t6}</div>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}
function _temp3(l) {
  return l.language;
}
function _temp2(i) {
  return i.documentId;
}
function _temp(filters, values) {
  if (filters.length === 0) {
    return true;
  }
  return filters.some(f => values.includes(f));
}